import React from 'react';
import { Col, Form, Row, Space, Typography } from 'antd';
import styled from 'styled-components';

import { SaveOutlined } from '@ant-design/icons';

import { StyledButton } from '../../components/Button';
import { FormInput } from '../../components/forms/FormInput';
import { FormSelect } from '../../components/forms/FormSelect';

import {
  CandidateConsent,
  CandidateConsentStatus,
  consentTypeMap,
  nextCandidateConsentStatuses,
} from './Consents.types';

const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 576px) {
    flex-direction: row;
  }
`;

type EditCandidateConsentFormValues = {
  status: CandidateConsentStatus;
};

export const EditCandidateConsentForm: React.FC<{
  consent?: CandidateConsent;
  onSubmit(values: EditCandidateConsentFormValues): void;
  onCancel(): void;
}> = ({ consent, onSubmit, onCancel }) => {
  if (!consent) {
    return null;
  }

  return (
    <Form<EditCandidateConsentFormValues>
      key={consent.id}
      colon={false}
      layout="vertical"
      initialValues={{
        consentType: consentTypeMap[consent.type],
        client: consent.client?.name,
        project: consent.project?.name,
        status: undefined,
      }}
      onFinish={onSubmit}
      style={{ padding: '0 15px' }}
      requiredMark={false}
    >
      <Row gutter={[10, 5]}>
        <Col xs={24}>
          <StyledHeader>
            <Typography.Title level={5}>Editing consent</Typography.Title>

            <Space style={{ marginLeft: 'auto' }}>
              <StyledButton onClick={onCancel}>Cancel</StyledButton>
              <StyledButton htmlType="submit" type="primary" icon={<SaveOutlined />}>
                Save
              </StyledButton>
            </Space>
          </StyledHeader>
        </Col>
        <Col xs={24} md={12}>
          <FormInput label="Consent type" name="consentType" disabled />

          {consent.client && <FormInput label="Client" name="client" disabled />}

          {consent.project && <FormInput label="Project" name="project" disabled />}

          <FormSelect
            label="Status"
            required
            name="status"
            rules={[{ required: true, message: 'Required' }]}
            options={nextCandidateConsentStatuses[consent.status].map((nextConsentStatus) => ({
              value: nextConsentStatus,
              content: nextConsentStatus.charAt(0) + nextConsentStatus.slice(1).toLowerCase(),
            }))}
          />
        </Col>
      </Row>
    </Form>
  );
};
